//Numbers from 0 to 52 without repetitions

const numberFrom0to52 = () => {
  return Array.from(Array(52), (_, i) => i);
};

export default numberFrom0to52;
